var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-writer.ts
import { css } from "@adornis/chemistry/directives/css";
import { inputToken } from "@adornis/chemistry/elements/theming/input-token";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ElementsPlainWriter } from "./x-plain-writer";
var ElementsWriter = class extends ElementsPlainWriter {
  constructor() {
    super(...arguments);
    this["placeholder-mode"] = "floating";
    this.minheight = "";
  }
  get inputToken() {
    return inputToken(this);
  }
  styles() {
    return [super.styles(), { ":host": { "--placeholder-color": this.colors.neutral_800 } }];
  }
  get _showLabel() {
    return this.value.value !== void 0 && this.value.value !== null && this.value.value !== "" || !!this.error;
  }
  render() {
    return html`
      ${this._label()}
      <x-flex
        flex
        ${css({
      width: "100%",
      height: "100%",
      ...this.inputToken,
      ...this.minheight ? { minHeight: this.minheight, maxHeight: "200px", overflow: "auto" } : {},
      ...this.error ? { borderColor: this.colors.tone.error } : {},
      justifyContent: "unset",
      flexDirection: "column"
    })}
      >
        <div id="toolbarContainer"></div>
        <x-flex horizontal flex space="sm">
          ${this["placeholder-mode"] === "prefix" && this._showLabel && this.placeholder ? html`
                <div ${css({ color: "var(--placeholder-color, #aaa)", pointerEvents: "none", whiteSpace: "nowrap" })}>
                  ${this.placeholder}
                </div>
              ` : nothing}
          ${super.render()}
        </x-flex>
      </x-flex>
    `;
  }
  toolbarContainer() {
    return nothing;
  }
  _label() {
    return this.error || this.placeholder && this["placeholder-mode"] === "floating" ? html`
          <x-text
            ${css({
      marginLeft: this.spacing.md,
      opacity: this._showLabel ? "1" : "0",
      transform: this._showLabel ? "translateY(0)" : "translateY(20px)",
      transition: "opacity .12s ease, transform .12s ease"
    })}
            tone=${this.error ? "error" : "subtle"}
          >
            ${this.error || this.placeholder}
          </x-text>
        ` : nothing;
  }
};
__decorateClass([
  property()
], ElementsWriter.prototype, "placeholder-mode", 2);
__decorateClass([
  property()
], ElementsWriter.prototype, "minheight", 2);
ElementsWriter = __decorateClass([
  customElement("x-writer")
], ElementsWriter);
export {
  ElementsWriter
};
